module.exports = __webpack_public_path__ + "static/img/login_pic1.c055529.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login_pic1.png
// module id = Vwt4
// module chunks = 1